var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16659 2.75H12.8333C13.8458 2.75 14.6666 3.57081 14.6666 4.58333V5.5H18.3333C19.3458 5.5 20.1666 6.32081 20.1666 7.33333V17.4167C20.1666 18.4292 19.3458 19.25 18.3333 19.25H3.66659C2.65406 19.25 1.83325 18.4292 1.83325 17.4167V7.33333C1.83325 6.32081 2.65406 5.5 3.66659 5.5H7.33325V4.58333C7.33325 3.57081 8.15406 2.75 9.16659 2.75ZM3.66659 7.33333H7.33325H14.6666H18.3333V11.9167H11.9166H10.0833H3.66659V7.33333ZM3.66659 17.4167V13.75H10.0833V14.6667H11.9166V13.75H18.3333V17.4167H3.66659ZM12.8333 4.58333V5.5H9.16658V4.58333H12.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.5f3e2a0243b579620e3a1f33259a70c0.svg";
export { ForwardRef as ReactComponent };